module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-700.8293542e.woff2";